import { createErrorHandler } from '@sentry/angular';
import { environment } from '../../environments/environment';

export const sentryErrorHandler = createErrorHandler({
  logErrors: !environment.production,
  showDialog: false,
  extractor: (error: any, defaultExtractor: (error: any) => any) => {
    const chunkLoadError: RegExp = /ChunkLoadError/;
    if (chunkLoadError.test(error.message)) {
      window.location.reload();
    } else {
      return defaultExtractor(error);
    }
  },
});
